import { createContext, useContext, useReducer } from 'react'
import { reducer } from './reducer'
import { useComponentIsMountedRef } from 'Hooks'
import { selectionTypes } from '../helpers'

SpreadSheetDataContext = createContext()

initialState = {
  columns: [],
  columnWidths: {},
  count: 9999
  ctxMenuEvt: undefined
  currentHighestRequested: 50
  editHistory: []
  edits: {}
  filters: {}
  isDragging: false
  isEscapingEditMode: false
  isFetching: false
  isInEditMode: false
  loading: true
  nodeOrder: []
  relationsMap: {}
  resizedColumnWidths: {}
  rowsToBeDeleted: {}
  selection: [0,0]
  selectionType: selectionTypes.CELL
  sorter: {}
  undoHistory: []
}

export SpreadSheetDataProvider = ({ children }) ->
  isMounted = useComponentIsMountedRef()
  [state, dispatch] = useReducer(reducer, initialState)

  protectedDispatch = (args...) ->
    return unless isMounted.current
    dispatch(args...)

  <SpreadSheetDataContext.Provider value={[state, protectedDispatch]}>
    { children }
  </SpreadSheetDataContext.Provider>

export useSpreadSheetData = () ->
  useContext(SpreadSheetDataContext)
